import AppColors from './AppColors.js';
import ControlColors from './ControlColors.js';

class ColorVariant {
  constructor(options = {}, base) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    this._primary = (_b = (_a = options.primary) !== null && _a !== void 0 ? _a : base === null || base === void 0 ? void 0 : base._primary) !== null && _b !== void 0 ? _b : '';
    this._secondary = (_d = (_c = options.secondary) !== null && _c !== void 0 ? _c : base === null || base === void 0 ? void 0 : base._secondary) !== null && _d !== void 0 ? _d : '';
    this._accent = (_f = (_e = options.accent) !== null && _e !== void 0 ? _e : base === null || base === void 0 ? void 0 : base._accent) !== null && _f !== void 0 ? _f : '';
    this._critical = (_h = (_g = options.critical) !== null && _g !== void 0 ? _g : base === null || base === void 0 ? void 0 : base._critical) !== null && _h !== void 0 ? _h : '';
    this._info = (_k = (_j = options.info) !== null && _j !== void 0 ? _j : base === null || base === void 0 ? void 0 : base._info) !== null && _k !== void 0 ? _k : '';
    this._success = (_m = (_l = options.success) !== null && _l !== void 0 ? _l : base === null || base === void 0 ? void 0 : base._success) !== null && _m !== void 0 ? _m : '';
    this._warning = (_p = (_o = options.warning) !== null && _o !== void 0 ? _o : base === null || base === void 0 ? void 0 : base._warning) !== null && _p !== void 0 ? _p : '';
    this.app = new AppColors(options.app, base === null || base === void 0 ? void 0 : base.app);
    this.controls = new ControlColors(options.controls, base === null || base === void 0 ? void 0 : base.controls);
  }
  get primary() {
    return this._primary;
  }
  get secondary() {
    return this._secondary;
  }
  get accent() {
    return this._accent;
  }
  get error() {
    return this._critical;
  }
  get info() {
    return this._info;
  }
  get success() {
    return this._success;
  }
  get warning() {
    return this._warning;
  }
  get messageError() {
    return this._warning;
  }
  toVuetifyOptions() {
    var _a, _b;
    return {
      brand: (_a = this.app.brandColor) !== null && _a !== void 0 ? _a : this.primary,
      'brand-login': (_b = this.app.brandLoginColor) !== null && _b !== void 0 ? _b : this.primary,
      primary: this.primary,
      secondary: this.secondary,
      accent: this.accent,
      error: this.error,
      info: this.info,
      success: this.success,
      warning: this.warning,
      messageError: this.messageError
    };
  }
}

export { ColorVariant as default };
